import {
    GET_SERVICE_TYPES, ADD_SERVICE_TYPE, SERVICE_TYPE_ERROR
} from '../actions/types';


const initialState = { servicetypes: [], servicetype: null, loading: true, error: {} }

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_SERVICE_TYPES:
            return {
                ...state,
                servicetypes: payload,
                loading: false
            }
        case ADD_SERVICE_TYPE:
            return {
                ...state,
                servicetypes: [...state.servicetypes, payload],
                loading: false
            }
        case SERVICE_TYPE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            }
        default:
            return state;
    }

}